import { inject, Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs';

import { PaymentMethodsService } from '../services/payment-methods.service';

@Pipe({ name: 'paymentMethod' })
export class PaymentMethodPipe implements PipeTransform {
    private paymentMethodsService = inject(PaymentMethodsService);

    transform(paymentMethodId: string): Observable<string | null> {
        return this.paymentMethodsService.allPaymentMethodsForCity$.pipe(
            filter((paymentMethods) => paymentMethods !== null && paymentMethods.length > 0),
            map((paymentMethods) => {
                const filter = paymentMethods!.filter((paymentMethod) => paymentMethod.id === paymentMethodId);
                if (filter.length) {
                    return filter[0].name;
                }
                return 'Unknown';
            }),
        );
    }
}
